import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { GoogleLogo, EnvelopeSimple, ArrowLeft } from "@phosphor-icons/react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function loginGoogle() {
  const redirectUrl = window.location.origin + "/auth/google";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function SocialOtpAuth() {
  const { requestOtp, verifyOtp } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("idle"); // idle | otp-email | otp-code
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const sendCode = async () => {
    if (!email) { toast.error("Masukkan email"); return; }
    setLoading(true);
    const res = await requestOtp(email);
    setLoading(false);
    if (res.ok) { toast.success("Kode OTP dikirim ke email Anda"); setMode("otp-code"); }
    else toast.error(res.error);
  };

  const verify = async () => {
    setLoading(true);
    const res = await verifyOtp(email, code);
    setLoading(false);
    if (res.ok) { toast.success("Berhasil masuk"); navigate(res.user.role === "admin" ? "/admin" : "/"); }
    else toast.error(res.error);
  };

  return (
    <div className="mt-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex-1 h-px bg-white/10" />
        <span className="text-[10px] uppercase tracking-widest text-zinc-600">atau</span>
        <div className="flex-1 h-px bg-white/10" />
      </div>

      {mode === "idle" && (
        <div className="space-y-2.5">
          <Button data-testid="google-login-btn" onClick={loginGoogle} variant="outline"
            className="w-full rounded-none border-white/15 bg-white/5 hover:bg-white hover:text-black h-11 gap-2 font-semibold">
            <GoogleLogo size={18} weight="bold" /> Lanjutkan dengan Google
          </Button>
          <Button data-testid="otp-start-btn" onClick={() => setMode("otp-email")} variant="outline"
            className="w-full rounded-none border-white/15 bg-white/5 hover:bg-primary hover:text-black h-11 gap-2 font-semibold">
            <EnvelopeSimple size={18} weight="bold" /> Masuk dengan Kode OTP Email
          </Button>
        </div>
      )}

      {mode === "otp-email" && (
        <div className="space-y-3">
          <div>
            <Label className="text-xs uppercase tracking-widest text-zinc-400">Email</Label>
            <Input data-testid="otp-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 bg-zinc-900 border-zinc-800 focus:ring-primary focus:border-primary rounded-none" placeholder="anda@email.com" />
          </div>
          <Button data-testid="otp-send-btn" onClick={sendCode} disabled={loading}
            className="w-full bg-primary text-black font-bold hover:bg-cyan-300 rounded-none h-11">
            {loading ? "Mengirim..." : "Kirim Kode"}
          </Button>
          <button onClick={() => setMode("idle")} className="text-xs text-zinc-500 hover:text-primary flex items-center gap-1 mx-auto"><ArrowLeft size={12} /> Kembali</button>
        </div>
      )}

      {mode === "otp-code" && (
        <div className="space-y-3">
          <p className="text-sm text-zinc-400">Kode dikirim ke <span className="text-primary">{email}</span></p>
          <div>
            <Label className="text-xs uppercase tracking-widest text-zinc-400">Kode OTP (6 digit)</Label>
            <Input data-testid="otp-code-input" value={code} onChange={(e) => setCode(e.target.value)} maxLength={6}
              className="mt-1.5 bg-zinc-900 border-zinc-800 focus:ring-primary focus:border-primary rounded-none tracking-[0.5em] text-center text-lg" placeholder="000000" />
          </div>
          <Button data-testid="otp-verify-btn" onClick={verify} disabled={loading}
            className="w-full bg-primary text-black font-bold hover:bg-cyan-300 rounded-none h-11">
            {loading ? "Memverifikasi..." : "Verifikasi & Masuk"}
          </Button>
          <button onClick={sendCode} className="text-xs text-zinc-500 hover:text-primary mx-auto block">Kirim ulang kode</button>
        </div>
      )}
    </div>
  );
}
